import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { Alert, Box, Typography } from '@mui/material'

import { useStores } from 'admin/hooks'

const FlowSankey = () => {
  const { reportStore } = useStores()

  const transitions = useMemo(() => {
    const counts = new Map()
    ;(reportStore.driverRouteGroups || []).forEach((group) => {
      const seq = group.sequence || []
      for (let i = 0; i < seq.length - 1; i += 1) {
        const from = `${seq[i]?.areaName || ''}`.trim()
        const to = `${seq[i + 1]?.areaName || ''}`.trim()
        if (from && to) {
          const key = `${from}__${to}`
          counts.set(key, (counts.get(key) || 0) + 1)
        }
      }
    })

    return Array.from(counts.entries())
      .map(([key, value]) => {
        const [from, to] = key.split('__')
        return { from, to, value }
      })
      .sort((a, b) => b.value - a.value)
      .slice(0, 12)
  }, [reportStore.driverRouteGroups])

  const maxValue = transitions[0]?.value || 1

  if (!transitions.length) {
    return (
      <Alert
        severity="info"
        sx={{ mb: 2 }}
      >
        No transition flow available for selected filters.
      </Alert>
    )
  }

  return (
    <Box sx={{ mb: 2, border: '1px solid #e0e0e0', borderRadius: 1, p: 2 }}>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 700, mb: 1 }}
      >
        Area transition flow (Sankey-like)
      </Typography>
      {transitions.map((item) => (
        <Box
          key={`${item.from}-${item.to}`}
          sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.8 }}
        >
          <Typography
            variant="body2"
            sx={{ minWidth: 280 }}
          >
            {item.from} → {item.to}
          </Typography>
          <Box
            sx={{ flex: 1, height: 12, borderRadius: 6, bgcolor: '#e3f2fd', overflow: 'hidden' }}
          >
            <Box
              sx={{
                height: '100%',
                width: `${Math.max(8, (item.value / maxValue) * 100)}%`,
                bgcolor: '#1565c0',
              }}
            />
          </Box>
          <Typography
            variant="body2"
            sx={{ width: 28, textAlign: 'right' }}
          >
            {item.value}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export default observer(FlowSankey)
